import "./pdfEmployeeExportReport.css";
import React from "react";
import { FetchedCompanyLogoContext } from "../../fetchedCompanyLogo";
import { useState, useContext, useEffect } from "react";
import strings from "../../../utils/property-file/employeeLevelPdf.json";
import { EmployeeAttendanceContext } from "../../employeeAttendance";
import moment from "moment";
import { TimeDifferenceCalculator } from "../../../utils/commonFunction/timeConvertor";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import constants from "../../../utils/constants";

export default function PdfEmployeeExportReport() {
  const nav = useNavigate();
  // This method is used for the printing the PDF(Portable Document format)
  function createPDF() {
    window.print();
    window.onafterprint = function () {
    localStorage.removeItem(strings.selectedName);
    localStorage.removeItem(strings.selectedEmpValue);
    localStorage.removeItem(strings.startDateLabel);
    localStorage.removeItem(strings.endDateLabel);
    localStorage.removeItem(strings.selectedEmployeeId);
      nav(constants.navigationLink.empProfile);
    };
  }
  const { employeeAttendance, setEmployeeAttendance } = useContext(
    EmployeeAttendanceContext
  );
  const { companyLogo } = useContext(FetchedCompanyLogoContext);
  const firebaseImageString = companyLogo;
  const [base64String, setBase64String] = useState(null);
  const companyName = localStorage.getItem("company_info");
  const selectedEmployeeName = localStorage.getItem(
    strings.selectedName
  );
  const startDate = localStorage.getItem(strings.startDateLabel);
  const endDate = localStorage.getItem(strings.endDateLabel);
  const currentTime = new Date();
  const selectedEmpId = localStorage.getItem(strings.selectedEmpValue);
  const employeeID= localStorage.getItem(strings.selectedEmployeeId)

  useEffect(() => {
    if (firebaseImageString) {
      fetchImageAndConvertToBase64(firebaseImageString);
    }
  }, [firebaseImageString]);

  /* 1.This method is used for converting the normal image into the base64 image
  2 .Why converting into base 64 ?
  Because at the time of print pdf format not supported the normal image print thats why we converting into base 64
  */
  const fetchImageAndConvertToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onload = function (e) {
        const base64String = e.target.result;
        setBase64String(base64String);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      return ;
    }
  };

  const fetchEmployeeAttendanceReport = async () => {
    try {
      const response = await api.exportEmployeeAttendance(
        selectedEmpId,
        moment(startDate).format(strings.ddMMYYformatLabel),
        endDate != "null"
          ? moment(endDate).format(strings.ddMMYYformatLabel)
          : moment(startDate).format(strings.ddMMYYformatLabel)
      );
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployeeAttendance(data.finalAttendanceList);
        } else {
          setEmployeeAttendance([]);
        }
      }
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
    }
  };

  useEffect(() => {
    fetchEmployeeAttendanceReport();
  }, []);

  function handleBackButton() {
    localStorage.removeItem(strings.selectedName);
    localStorage.removeItem(strings.selectedEmpValue);
    localStorage.removeItem(strings.startDateLabel);
    localStorage.removeItem(strings.endDateLabel);
    localStorage.removeItem(strings.selectedEmployeeId);
    nav(constants.navigationLink.empProfile);
  }

  if (
    !localStorage.getItem(strings.selectedName) ||
    !localStorage.getItem(strings.selectedEmpValue) ||
    !localStorage.getItem(strings.startDateLabel) ||
    !localStorage.getItem(strings.endDateLabel)
  ) {
    nav(constants.navigationLink.empProfile);
  }

  return (
    <div className="main-container-with-btn-attendance-report">
      <div className="employee-pdf-main-container">
        <div className="download-button-employee-report">
          <button className="me-2" onClick={() => handleBackButton()}>
            {strings.backButton}
          </button>
          <button onClick={() => createPDF()}>{strings.downloadLabel}</button>
        </div>
        <div id="pdf-content">
          <div className="company-information-employee-attendance-report mt-3">
            <div className="company-logo-in-attendance-report-employee">
              {base64String ? (
                <img
                  src={base64String}
                  alt="company-logo"
                  className="company-logo-employee-attendance me-2"
                />
              ) : null}
            </div>
            <div className="company-name-employee-report">
              <h1>{companyName}</h1>
            </div>
          </div>
          <div className="employee-attendance-information">
            <div className="employee-name-attendance-report report-type-employee-attendance">
              {strings.reportNameLabel}
            </div>
            <div className="employee-name-attendance-report">
              {strings.generationLabel}{" "}
              {moment(currentTime).format(strings.generationDateFormatLabel)}
            </div>
            <div className="employee-name-attendance-report">
              {strings.employeeName} {selectedEmployeeName}
            </div>
            <div className="employee-name-attendance-report">
              {strings.empIdLabel} {employeeID}
            </div>
            <div className="employee-name-attendance-report">
              {startDate && endDate !== strings.nullLabel
                ? strings.rangeDateLabel
                : strings.dateLabel}{" "}
              {startDate && endDate != strings.nullLabel
                ? moment(startDate).format(strings.anotherDateFormat) +
                  strings.toStringLabel +
                  moment(endDate).format(strings.anotherDateFormat)
                : moment(startDate).format(strings.anotherDateFormat)}
            </div>
          </div>
          <div className="employee-attendance-data">
            <table className="company-report-table">
              <thead className="company-level-export-thead">
                <tr>
                  <th>{strings.dateHeadTable}</th>
                  <th>{strings.checkInHeadTable}</th>
                  <th>{strings.checkoutHeadTable}</th>
                  <th>{strings.durationLabel}</th>
                  <th>{strings.statusLabel}</th>
                </tr>
              </thead>
              <tbody>
                {employeeAttendance != null && employeeAttendance.length > 0
                  ? employeeAttendance.map((item, index) => {
                      return (
                        <tr key={index} className="employee-attendance-data">
                          <td>{moment(item.date).format(strings.anotherDateFormat)}</td>
                          <td>
                            {item.SignIn !== strings.naLabel
                              ? moment(item.SignIn).format(strings.timeFormat)
                              : strings.naLabel}
                          </td>
                          <td>
                            {item.SignOut !== strings.naLabel
                              ? moment(item.SignOut).format(strings.timeFormat)
                              : strings.naLabel}
                          </td>
                          <td>
                            {item.SignOut !== strings.naLabel &&
                            item.SignIn !== strings.naLabel ? (
                              <TimeDifferenceCalculator
                                time1={moment(item.SignIn).format(
                                  strings.timeFormat
                                )}
                                time2={moment(item.SignOut).format(
                                  strings.timeFormat
                                )}
                              />
                            ) : (
                              strings.naLabel
                            )}
                          </td>
                          <td>{item.Status}</td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
